import script from "./SeatsIo.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatsIo.vue?vue&type=script&setup=true&lang=js"

import "./SeatsIo.vue?vue&type=style&index=0&id=5724a10e&lang=scss"

const __exports__ = script;

export default __exports__